import {Injectable} from '@angular/core';
import {map, Observable, of, ReplaySubject, tap} from 'rxjs';
import {AppIdAndNameApiModel, PodioOrgApiModel, PodioService} from "api-client";

@Injectable()
export class PodioOrgsService {

    private dataObs$ = new ReplaySubject<PodioOrgApiModel[]>(1);
    private appsBySpaceId = new Map<number, AppIdAndNameApiModel[]>();

    constructor(private podioService: PodioService) {
    }

    /**
     *
     * @param forceRefresh
     * @returns {ReplaySubject} Note that this cannot be transformed to a promise!
     */
    getPodioOrgs(forceRefresh?: boolean): ReplaySubject<PodioOrgApiModel[]> {
        if (!this.dataObs$.observers.length || forceRefresh) {
            this.podioService.getOrgs().subscribe(
                data => this.dataObs$.next(data),
                error => {
                    this.dataObs$.error(error);
                    // Recreate the Observable as after Error we cannot emit data anymore
                    this.dataObs$ = new ReplaySubject(1);
                }
            );
        }

        return this.dataObs$;
    }

    getPodioApps(spaceIds: number[]): Observable<AppIdAndNameApiModel[]> {
      const uniqueSpaceIds = [...new Set(spaceIds)].filter(spaceId => !!spaceId);
      const missingSpaceIds = uniqueSpaceIds.filter(spaceId => !this.appsBySpaceId.has(spaceId));

      if (!missingSpaceIds.length) {
        return of(this.appsFromCache(uniqueSpaceIds));
      }

      return this.podioService.getApps({space_ids: missingSpaceIds}).pipe(
        tap(apps => {
          missingSpaceIds.forEach(spaceId => this.appsBySpaceId.set(spaceId, []));
          apps.forEach(app => {
            if (!app.space_id) {
              return;
            }
            this.appsBySpaceId.get(app.space_id)?.push(app);
          });
        }),
        map(() => this.appsFromCache(uniqueSpaceIds))
      );
    }

    private appsFromCache(spaceIds: number[]): AppIdAndNameApiModel[] {
      return spaceIds.reduce(
        (apps, spaceId) => apps.concat(this.appsBySpaceId.get(spaceId) || []),
        [] as AppIdAndNameApiModel[]
      );
    }

}
